import * as types from './../constants/actionTypes';

const initialState = {
    visible: false
};

const alertReducer = (state=initialState, action) => {
    switch(action.type){

    case types.ALERT_SUCCESS:
         return{
             ...state,
             type: "success",
             message: action.message,
             visible: true
         };

    case types.ALERT_FAILED:
        return {
            ...state,
            type: 'error',
            message: action.message,
            visible: true
        };
    case types.NOT_SHOW_ALERT_MESSAGE:
        return {
            ...state,
            type: undefined,
            message: undefined,
            visible: false
        };

    case types.LOCATION_CHANGE:
        return {
            ...state,
            type: undefined,
            message: undefined,
            visible: false
        };
       default:
        return state;
    }
};
export default alertReducer;



// WEBPACK FOOTER //
// ./src/reducers/alertReducer.js